import axios, { InternalAxiosRequestConfig } from 'axios';
import { StorageKey } from '../types';
import { AppLinks } from '../data';


export interface CustomAxiosRequestConfig extends InternalAxiosRequestConfig {
  requiresAuth?: boolean;
}

const axiosInstance = axios.create({});

axiosInstance.interceptors.request.use(
  (config) => {
    if ((config as CustomAxiosRequestConfig).requiresAuth !== false) {
      if (typeof window !== 'undefined') { // Ensure we are in a browser environment
        const stored = localStorage.getItem(StorageKey.UserToken);

        if (stored) {
          const tokenObj = JSON.parse(stored);

          if (tokenObj) {
            config.headers['Authorization'] = `Bearer ${tokenObj}`;
            // axios.defaults.headers.common = { Authorization: `Bearer ${tokenObj.token}` };
          }
        }
      }
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
  (response) => response,
async(error) => {
    if (error.response && error.response.status === 401) {
      if (typeof window !== 'undefined') { // Ensure we are in a browser environment
        const baseUrl = window.location.origin; // Gets current origin (http://localhost:3000 or https://yourdomain.com)
        const { default: store } = await import('@/store');
        const { REMOVE_USER } = await import('@/store/user');
        
        // 3. Dispatch logout action
        store.dispatch(REMOVE_USER());
        const loginPath = `/${AppLinks.PUBLIC.DASHBOARD}`;
        window.location.href = `${baseUrl}${loginPath}`;
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;